import { render, staticRenderFns } from "./RetentionTouchpointList.vue?vue&type=template&id=8f6a2cde&"
import script from "./RetentionTouchpointList.vue?vue&type=script&lang=js&"
export * from "./RetentionTouchpointList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports